import { HelpOutline } from '@mui/icons-material';
import { IconButton, IconButtonProps } from '@mui/material';
import React from 'react';

import { useSxStyles } from './useStyles';

export const InstructionButton = (props: IconButtonProps) => {
  const { sx, children, ...buttonProps } = props;

  const sxStyles = useSxStyles();

  return (
    <IconButton {...buttonProps} sx={{ ...sxStyles.help, ...sx }}>
      {!!children ? children : <HelpOutline />}
    </IconButton>
  );
};
